import {baseSelector, useSliceDispatch} from "../../utils";
import {HomeActions} from "./actions";
import {createSelector} from "@reduxjs/toolkit";
import {RootState} from "../../store";
import {useSelector} from "react-redux";
import {HomeSliceState} from "./reducers";

// type HomeDispatch = HomeActions;
export const useHomeDispatch = () => useSliceDispatch<HomeActions>();

export const selectHomeSlice = createSelector(
    [
        (state: RootState) => state.home,
        (state: RootState, keys: (keyof HomeSliceState)[]) => keys
    ],
    (slice, keys) => baseSelector(slice, keys)() // Call the baseSelector function here to get the selected props
);

export const useHomeSelector = (keys: (keyof HomeSliceState)[]) => {
    return useSelector((state: RootState) => selectHomeSlice(state, keys));
}


